module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-scroll-deff7766c5d0e66fefe0db4950f5aeef.svg";